// 工作流节点默认审批人分组
export enum EWorkflowStepHandlerRoleTeam {
  Custom = 0, // 自选用户
  SpecificRole = 1  // 指定角色
}